// Egresos del gestor (7-oct-2026).
export const managementExpenses = {
  categories: {
    cleaning: "Reinigung",
    laundry: "Wäscherei",
    maintenance: "Wartung und Reparaturen",
    supplies: "Ausstattung und Verbrauchsmaterial",
    utilities: "Nebenkosten",
    staff: "Personal",
    software: "Software und Tools",
    marketing: "Werbung",
    taxes: "Steuern und Abgaben",
    other: "Sonstiges",
  },

  restricted: "Die Verwaltungsausgaben sieht nur das Hauptkonto: Ihr Zugriff ist auf einige Unterkünfte beschränkt.",

  summary: {
    aria: "Übersicht der Ausgaben im Zeitraum. Wählen Sie einen Betrag, um die Tabelle zu filtern.",
    total: "Ausgaben gesamt",
    count: "{n} Ausgabe | {n} Ausgaben",
    charged: "An Eigentümer weiterberechnet",
    chargedHint: "Werden in deren Abrechnung abgezogen",
    own: "Eigene Ausgaben",
    ownHint: "Mindern Ihren Gewinn",
  },

  toolbar: {
    search: "Suchen",
    searchPlaceholder: "Bezeichnung oder Lieferant",
    clearSearch: "Suche leeren",
    category: "Kategorie",
    allCategories: "Alle",
    listing: "Unterkunft",
    allListings: "Alle",
    type: "Art",
    allTypes: "Alle",
    charged: "An Eigentümer weiterberechnet",
    own: "Eigene",
    create: "Neue Ausgabe",
  },

  table: {
    date: "Datum",
    category: "Kategorie",
    concept: "Bezeichnung",
    listing: "Unterkunft",
    chargedTo: "Zulasten von",
    amount: "Betrag",
    receipt: "Beleg",
    actions: "Aktionen",
    general: "Allgemein",
    management: "Verwaltung",
    ownerMissing: "Kein Eigentümer zugewiesen",
    notCharged: "Die Unterkunft wird nicht mehr verwaltet: Diese Ausgabe wird niemandem berechnet",
    vat: "MwSt. {pct} %",
    download: "Beleg herunterladen",
    edit: "Bearbeiten",
    remove: "Löschen",
  },

  empty: {
    title: "Keine Ausgaben in diesem Zeitraum",
    text: "Erfassen Sie, was Sie bezahlen (Reinigung, Wäscherei, Reparaturen, Software …), und entscheiden Sie, ob es an den Eigentümer weiterberechnet wird oder eine Ausgabe der Verwaltung ist.",
    create: "Ausgabe erfassen",
    filteredTitle: "Keine Ausgabe passt zu den Filtern",
    filteredText: "Versuchen Sie eine andere Suche oder entfernen Sie die Filter, um alle Ausgaben des Zeitraums zu sehen.",
    clear: "Filter entfernen",
  },

  load: {
    error: "Die Ausgaben konnten nicht geladen werden.",
    retry: "Erneut versuchen",
  },

  remove: {
    title: "Diese Ausgabe löschen?",
    message: "„{concept}“ ({amount}) zählt dann nicht mehr in der Analyse und in den Eigentümerabrechnungen.",
    confirm: "Löschen",
    done: "Ausgabe gelöscht",
    error: "Die Ausgabe konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
  },

  receiptError: "Der Beleg konnte nicht heruntergeladen werden.",

  drawer: {
    newTitle: "Neue Ausgabe",
    editTitle: "Ausgabe bearbeiten",
    newSubtitle: "Was Sie für die Verwaltung bezahlen – zulasten des Eigentümers oder Ihrer Verwaltung.",
    editSubtitle: "Änderungen erscheinen sofort in der Analyse und in den Abrechnungen.",
    close: "Schließen",
    sections: {
      expense: "Die Ausgabe",
      listing: "Unterkunft und Eigentümer",
      notes: "Notizen",
      receipt: "Beleg oder Rechnung",
    },
    fields: {
      concept: "Bezeichnung",
      conceptPlaceholder: "z. B. Endreinigung",
      category: "Kategorie",
      date: "Datum",
      supplier: "Lieferant",
      supplierPlaceholder: "z. B. Wäscherei Sonne",
      amount: "Betrag",
      vat: "MwSt.",
      vatHint: "Nur zur Information: Der Betrag ist das, was Sie bezahlt haben, inkl. MwSt.",
      listing: "Unterkunft",
      listingGeneral: "Allgemeine Verwaltungsausgabe (ohne Unterkunft)",
      unit: "Einheit",
      unitAll: "Gesamte Unterkunft",
      notesPlaceholder: "Alles, woran Sie sich später erinnern möchten",
    },
    charge: {
      label: "An den Eigentümer weiterberechnen",
      general: "Eine allgemeine Ausgabe gehört immer zur Verwaltung. Wählen Sie eine Unterkunft, um sie dem Eigentümer zu berechnen.",
      loading: "Unterkunft wird geprüft …",
      error: "Es konnte nicht geprüft werden, ob diese Unterkunft verwaltet wird.",
      retry: "Erneut versuchen",
      notManaged: "Diese Unterkunft ist nicht als verwaltet markiert: Die Ausgabe zählt als Ihre eigene.",
      notManagedMarked: "Die Unterkunft wird nicht mehr verwaltet: Die Ausgabe wird niemandem berechnet. Deaktivieren Sie die Option, um sie als eigene Ausgabe zu führen.",
      own: "Ohne Weiterberechnung zählt sie als eigene Ausgabe der Verwaltung.",
      owner: "Wird in der Abrechnung von {owner} abgezogen.",
      noOwner: "Der Unterkunft ist noch kein Eigentümer zugewiesen: Sie wird in der Abrechnung der Person abgezogen, die Sie zuweisen.",
    },
    receipt: {
      drop: "Foto oder PDF hierher ziehen",
      pick: "oder Datei auswählen",
      formats: "JPG, PNG, WEBP, HEIC oder PDF · max. 10 MB",
      current: "Gespeicherter Beleg",
      download: "Herunterladen",
      change: "Ersetzen",
      remove: "Entfernen",
      undo: "Rückgängig",
      willRemove: "Der Beleg wird beim Speichern entfernt.",
      willReplace: "ersetzt den gespeicherten",
      tooBig: "Die Datei ist größer als 10 MB.",
      badType: "Format nicht unterstützt: Laden Sie ein Foto (JPG, PNG, WEBP oder HEIC) oder ein PDF hoch.",
    },
    errors: {
      required: "Pflichtfeld.",
      category: "Wählen Sie eine Kategorie.",
      amount: "Geben Sie einen Betrag größer als 0 ein.",
      vat: "Geben Sie einen Prozentsatz zwischen 0 und 100 ein.",
      review: "Bitte prüfen Sie die markierten Felder.",
      generic: "Die Ausgabe konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    },
    discard: {
      title: "Änderungen verwerfen?",
      message: "Ihre Eingaben zu dieser Ausgabe gehen verloren.",
      confirm: "Verwerfen",
      cancel: "Weiter bearbeiten",
    },
    cancel: "Abbrechen",
    save: "Ausgabe speichern",
    saveChanges: "Änderungen speichern",
    saving: "Wird gespeichert …",
    created: "Ausgabe gespeichert",
    updated: "Änderungen gespeichert",
    outOfPeriod: "Gespeichert. Das Datum ({date}) liegt außerhalb des angezeigten Zeitraums.",
  },
};
